import { render, staticRenderFns } from "./DialogFuncionalidades.vue?vue&type=template&id=98a0560a&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./DialogFuncionalidades.vue?vue&type=style&index=0&id=98a0560a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a0560a",
  null
  
)

export default component.exports